//@flow
import React from 'react';
import Slider from 'react-slick';
import CategoryThumbnail from './CategoryThumbnail.react';

import type CategoryModel from '../../Stores/MemberCategories/categoryModel';

type Props = {
  className:string,
  categories:CategoryModel[],
  activeUrlKey?:string,
  isMember?:boolean,
  isOffice?:boolean,
};

const sliderSettings = {
  autoplay: false,
  dots: false,
  infinite: false,
  slidesToScroll: 8,
  slidesToShow: 8,
  arrows: true,
  draggable: true,
  useCSS: true,
  responsive: [
    {
      breakpoint: 1280,
      settings: {
        slidesToScroll: 5,
        slidesToShow: 5,
      },
    },
    {
      breakpoint: 840,
      settings: {
        slidesToScroll: 4,
        slidesToShow: 4,
      },
    },
    {
      breakpoint: 640,
      settings: {
        slidesToScroll: 3,
        slidesToShow: 3,
      },
    },
  ],
};

export default function CategoriesSlider(props:Props) {
  const thumbnails = _getThumbnails(props);
  if (!thumbnails || !thumbnails.length) return null;

  return (
    <div>
      <div className={"categories-slider hide-for-small-only " + props.className}>
        <Slider {...sliderSettings}>
          {thumbnails}
        </Slider>
      </div>
      <div className={"categories-slider show-for-small-only " + props.className}>
        <h3>SHOP OUR CATEGORIES</h3>
        <div className="thumbnails-holder">
          {thumbnails}
        </div>
      </div>
    </div>
  );
}

function _getThumbnails(props:Props) {
  return props.categories.map((category, i) => {
    const urlKey = category.getUrlKey();
    const className = props.activeUrlKey !== urlKey ? 'category-thumbnail' :
      'category-thumbnail active';

    return (
      <div key={category.getId()} className="category-thumb-holder">
        <CategoryThumbnail
          category={category}
          className={className}
          isOffice={props.isOffice}
        />
      </div>
    );
  });
}
